import { useEffect, useState } from "react";

const KEY = "idro_consenso_v1";

export const leggiConsenso = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};

export const sceltaCompleta = (c) => !!c && typeof c.statistiche === "boolean";

export const salvaConsenso = (patch) => {
  const c = { ...leggiConsenso(), ...patch, necessari: true, data: new Date().toISOString() };
  localStorage.setItem(KEY, JSON.stringify(c));
  window.dispatchEvent(new Event("consenso-aggiornato"));
  return c;
};

export const apriPreferenze = () => window.dispatchEvent(new Event("consenso-apri"));

export const useConsenso = () => {
  const [c, setC] = useState(leggiConsenso);
  useEffect(() => {
    const h = () => setC(leggiConsenso());
    window.addEventListener("consenso-aggiornato", h);
    return () => window.removeEventListener("consenso-aggiornato", h);
  }, []);
  return c;
};
